(function ($) {
  var $table = $('.tests-evaluation');
  var $registerButton = $('.tests-register-button');
  var $summary = $('.tests-selection-summary');
  var $error = $('.tests-selection-error');

  if (!$table.length || !$registerButton.length) {
    return;
  }

  var language = (
    $table.closest('[data-listing-test-evaluation]').attr('data-language') ||
    document.documentElement.lang ||
    'fr'
  ).split(/[-_]/)[0].toLowerCase();

  var messages = language === 'en' ? {
    sameDateError: 'If you register for multiple tests, they must all be taken on the same day at the same campus.',
    selectedTests: 'Selected test(s): ',
    variationReadError: 'Unable to read variation attributes:',
    sentTests: 'Tests sent to Zoho:'
  } : {
    sameDateError: 'Si vous vous inscrivez à plusieurs tests, ceux-ci devront tous être effectués la même journée, au même campus.',
    selectedTests: 'Épreuve(s) sélectionnée(s) : ',
    variationReadError: 'Impossible de lire les attributs de variation :',
    sentTests: 'Tests envoyés à Zoho :'
  };

  var zohoBaseUrl =
    'https://forms.zohopublic.ca/csjr/form/' +
    'Inscriptionpreuvesdefranais/formperma/' +
    'QnnsBnsejIgtoUehq2mShdR-upg57GcIjj8fqzi_TDQ';

  var dateWarningIcon =
    '<svg class="test-date-warning-icon" width="98" height="87" viewBox="0 0 98 87" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M49 32.4006V50.1743M49 67.948H49.0443M42.8614 9.7024L6.3987 72.8284C4.37624 76.3298 3.36502 78.0805 3.51447 79.5173C3.64483 80.7706 4.29993 81.9094 5.31672 82.6504C6.48247 83.5 8.50075 83.5 12.5373 83.5H85.4627C89.4992 83.5 91.5175 83.5 92.6833 82.6504C93.7001 81.9094 94.3552 80.7706 94.4855 79.5173C94.635 78.0805 93.6238 76.3298 91.6013 72.8284L55.1386 9.70238C53.1234 6.21357 52.1158 4.46917 50.8012 3.88329C49.6545 3.37224 48.3455 3.37224 47.1988 3.88329C45.8842 4.46917 44.8766 6.21358 42.8614 9.7024Z" stroke="#39AFE1" stroke-opacity="0.996078" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"></path>' +
    '</svg>';

  function showDateError(message) {
    $error
      .empty()
      .append(dateWarningIcon)
      .append(document.createTextNode(message))
      .show();
  }

  /**
   * Retourne les données de la ligne
   * selon la date sélectionnée.
   */
  function getRowData($row) {
    var $select = $row.find('.test-date-select');
    var $option = $select.find('option:selected');

    if (!$option.length) {
      return null;
    }

    var variationAttributes = {};

    try {
      variationAttributes = JSON.parse(
        $option.attr('data-variation-attributes') || '{}'
      );
    } catch (e) {
      console.error(
        messages.variationReadError,
        e
      );

      variationAttributes = {};
    }

    return {
      row: $row,

      checkbox:
        $row.find('.test-checkbox'),

      examName:
        $row.attr('data-epreuve') || '',

      userId:
        $row.attr('data-user-id') || '',

      productId:
        $option.attr('data-product-id') ||
        $row.attr('data-formation-id') ||
        '',

      variationId:
        $option.attr('data-variation-id') ||
        $option.val() ||
        '',

      variationAttributes:
      variationAttributes,

      date:
        $option.attr('data-exam-date') || '',

      dateKey:
        $option.attr('data-date-key') || '',

      campus:
        $option.attr('data-campus') || '',

      expired:
        $option.attr('data-expired') === '1',

      hasDate:
        $option.attr('data-has-date') === '1'
    };
  }

  /**
   * Retourne tous les tests cochés.
   */
  function getSelectedTests() {
    var tests = [];

    $table.find('tbody tr').each(function () {
      var $row = $(this);
      var data = getRowData($row);

      if (
        data &&
        data.checkbox.length &&
        data.checkbox.is(':checked')
      ) {
        tests.push(data);
      }
    });

    return tests;
  }

  /**
   * Campus + état checkbox.
   */
  function updateCampus($row) {
    var data = getRowData($row);

    if (!data) {
      return;
    }

    var $campusLabel =
      $row.find('.test-campus-label');

    var $campusCell =
      $row.find('.col-campus');

    $campusLabel.text(data.campus);

    if ($campusCell.length) {
      $campusCell.toggleClass(
        'is-empty',
        data.campus === ''
      );
    }

    if (data.checkbox.length) {
      data.checkbox.prop(
        'disabled',
        !data.hasDate || data.expired
      );

      if (!data.hasDate || data.expired) {
        data.checkbox.prop(
          'checked',
          false
        );
      }
    }
  }

  /**
   * Toutes les épreuves doivent être
   * à la même date.
   */
  function validateSameDate($changedCheckbox) {
    var tests = getSelectedTests();

    if (tests.length <= 1) {
      $error
        .hide()
        .empty();

      return true;
    }

    var referenceDate = tests[0].dateKey;
    var referenceDateLabel = tests[0].date;

    var hasDifferentDate = tests.some(function (test) {
      return test.dateKey !== referenceDate;
    });

    if (!hasDifferentDate) {
      $error
        .hide()
        .empty();

      return true;
    }

    $changedCheckbox.prop(
      'checked',
      false
    );

    showDateError(
      messages.sameDateError
    );

    return false;
  }

  /**
   * Désactive les épreuves dont la date
   * diffère de celle déjà sélectionnée.
   */
  function updateCheckboxAvailability() {
    var tests = getSelectedTests();
    var referenceDate = tests.length
      ? tests[0].dateKey
      : '';
    var hasUnavailableDates = false;

    $table.find('tbody tr').each(function () {
      var data = getRowData($(this));

      if (!data || !data.checkbox.length) {
        return;
      }

      var hasDifferentDate =
        referenceDate !== '' &&
        !data.checkbox.is(':checked') &&
        data.dateKey !== referenceDate;

      if (hasDifferentDate) {
        hasUnavailableDates = true;
      }

      data.checkbox.prop(
        'disabled',
        !data.hasDate ||
        data.expired ||
        hasDifferentDate
      );
    });

    if (hasUnavailableDates) {
      showDateError(
        messages.sameDateError
      );
    } else {
      $error
        .hide()
        .empty();
    }
  }

  /**
   * Résumé + bouton.
   */
  function updateGlobalButton() {
    var tests = getSelectedTests();

    if (!tests.length) {
      $registerButton.hide();
      $summary.empty();

      return;
    }

    var names = tests.map(function (test) {
      return test.examName;
    });

    var date = tests[0].date;

    $summary
      .empty()
      .append(
        $('<strong>').text(messages.selectedTests)
      )
      .append(
        document.createTextNode(
          names.join(', ') +
          (date ? ' — ' + date : '')
        )
      );

    $registerButton.show();
  }

  /**
   * Changement de date.
   */
  $table.on(
    'change',
    '.test-date-select',
    function () {
      var $row =
        $(this).closest('tr');

      var $checkbox =
        $row.find('.test-checkbox');

      $checkbox.prop(
        'checked',
        false
      );

      updateCampus($row);
      updateCheckboxAvailability();
      updateGlobalButton();
    }
  );

  /**
   * Checkbox.
   */
  $table.on(
    'change',
    '.test-checkbox',
    function () {
      var $checkbox = $(this);

      if ($checkbox.is(':checked')) {
        validateSameDate($checkbox);
      }

      updateCheckboxAvailability();
      updateGlobalButton();
    }
  );

  /**
   * Bouton inscription / panier.
   */
  $registerButton.on(
    'click',
    function (e) {
      e.preventDefault();

      var tests = getSelectedTests();

      if (!tests.length) {
        return;
      }

      var dateKey =
        tests[0].dateKey;

      var invalidDate =
        tests.some(function (test) {
          return test.dateKey !== dateKey;
        });

      if (invalidDate) {
        showDateError(
          messages.sameDateError
        );

        return;
      }

      /**
       * Construction du formulaire Zoho.
       */
      var formationIds =
        tests.map(function (test) {
          return test.productId;
        });

      var variationIds =
        tests.map(function (test) {
          return test.variationId;
        });

      var params =
        new URLSearchParams();

      params.set(
        'epreuveId',
        formationIds.join(',')
      );

      params.set(
        'variationId',
        variationIds.join(',')
      );

      params.set(
        'userId',
        tests[0].userId
      );

      var formUrl =
        zohoBaseUrl +
        '?' +
        params.toString();

      console.log(
        messages.sentTests,
        tests.map(function (test) {
          return {
            name:
            test.examName,

            productId:
            test.productId,

            variationId:
            test.variationId,

            date:
            test.date
          };
        })
      );

      window.location.href = formUrl;
    }
  );

  /**
   * Initialisation.
   */
  $table
    .find('tbody tr')
    .each(function () {
      updateCampus($(this));
    });

  updateCheckboxAvailability();
  updateGlobalButton();

})(jQuery);
